/**
 * COPPER ROAD - Loading Spinner
 */
import React from 'react';
import { T, fonts } from '../theme';

export default function LoadingSpinner({ fullScreen = true, message = "Loading..." }) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: fullScreen ? '100vh' : 'auto',
            padding: fullScreen ? 0 : '40px 0',
            background: fullScreen ? '#1c2532' : 'transparent',
            fontFamily: fonts.heading,
            color: T.copperLight,
        }}>
            <style>
                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .cr-spinner {
                    width: 48px;
                    height: 48px;
                    border: 4px solid rgba(212, 137, 90, 0.2);
                    border-top: 4px solid #D4895A;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 20px;
                }
                `}
            </style>
            <div className="cr-spinner"></div>
            <div style={{ fontSize: 18, letterSpacing: 2, fontWeight: 'bold' }}>{message.toUpperCase()}</div>
        </div>
    );
}
